// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IGenderType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class GenderType implements IGenderType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Male GenderType
	**/
    get M(): IGenderType {
        return this.FromId(1);
    }
    /**
		Returns Female GenderType
	**/
    get F(): IGenderType {
        return this.FromId(2);
    }
    /**
		Returns Unknown GenderType
	**/
    get U(): IGenderType {
        return this.FromId(3);
    }
    /**
		Returns Non-binary/unspecified  GenderType
	**/
    get X(): IGenderType {
        return this.FromId(4);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'M', displayValue: 'Male', description: 'Male gender for the customer', sortOrder: 1, active: true });
        this._dictionary.add('2', { id: 2, value: 'F', displayValue: 'Female', description: 'Female gender for the customer', sortOrder: 2, active: true });
        this._dictionary.add('3', { id: 3, value: 'U', displayValue: 'Unknown', description: 'Gender unknown for the customer', sortOrder: 3, active: false });
        this._dictionary.add('4', { id: 4, value: 'X', displayValue: 'Non-binary unspecified', description: 'Non-binary unspecified', sortOrder: 4, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IGenderType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IGenderType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IGenderType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IGenderType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IGenderType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
